import router from './router'
// import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'
import store from '@/store'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/register', '/forget-password'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  if (to.meta.keeps && from.meta.keep) {
    await new Promise(resolve => {
      store.commit('keepAlive/SET_LIST', [from.name])
      setTimeout(() => {
        resolve()
      }, 0)
    })
  } else if (store.state.keepAlive.list.length !== 0) {
    setTimeout(() => {
      store.commit('keepAlive/SET_LIST', [])
    }, 0)
  }

  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  const userInfo = store.state.user.userInfo

  if (userInfo.au) {
    if (userInfo.state !== 9 && to.path !== '/state') {
      next({ path: '/state' })
      NProgress.done()
      return
    }
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      next()
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
